import $ from 'gridstrap/lib/gs-zepto';
import { data } from '../data';

export class GSProductList {

	//
	// Properties
	//

	private root;
	private moreButton;
	private clearButton;

	products;
	items;
	filters;

	get dataId()           { return this.root.data('gsProductListDataId'); }
	set isFiltering(value) { this.root.toggleClass('is-filtering', !!value); }
	set isEmpty(value)     { this.root.toggleClass('is-empty', !!value); }

	//
	// Initializations & Event Listeners
	//

	constructor(root) {
		this.root = $(root);
	}

	sort(property, direction) {
		let products = this.products;
		products.current = [...products.all];

		products.current.sort((objA, objB) => {
			const valA = property.split('.').reduce((o, i) => o[i], objA);
			const valB = property.split('.').reduce((o, i) => o[i], objB);
			return direction === 'asc' ? valA - valB : valB - valA;
		});
	}

	gsOnInit() {
		this.moreButton  = this.root.find('.gs-Button[role~="more"]') .gs(0);
		this.items       = this.root.find('.gs-ProductList-items')    .gs(0);
		this.filters     = this.root.find('.gs-ProductList-sidebar')  .gs(0);
		this.clearButton = this.root.find('.gs-Button[role~="clear"]').gs(0);

		this.clearButton.root.on('click', () => this.filters.clear());
		if (this.moreButton) this.moreButton.root.on('click', () => this.items.loadMore());
	}

	async gsOnDataReady() {
		if (!this.dataId) return;

		let all: any = await data.get(this.dataId);
		let current = [...all];
		this.products = { all, current };
		this.filters.gateAll(all);
		current.splice(0, 20);
	}

	gsOnDestroy() {
		this.moreButton.root.off();
	}
}
